import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { Access } from '../../api/sharingApi';
import { fill } from './fill';
import './sharing.css';

interface SharedBannerProps {
  access?: Access | null;
}

/** Whose this is and what you may do with it. Nothing for your own things. */
const SharedBanner: React.FC<SharedBannerProps> = ({ access }) => {
  const { t } = useLanguage();
  if (!access || access.role === 'owner') return null;

  return (
    <div className="shared-banner">
      <span className="shared-banner-owner">
        {fill(t.sharing.sharedBy, { name: access.owner.name })}
      </span>
      <span className="shared-banner-sep">·</span>
      <span>{access.role === 'editor' ? t.sharing.youCanEdit : t.sharing.youCanView}</span>
      {access.last_edited_by && (
        <span className="shared-banner-last">
          {fill(t.sharing.lastEditedBy, { name: access.last_edited_by })}
        </span>
      )}
    </div>
  );
};

export default SharedBanner;
